<template>
  <div>
    <TasksComponent />
  </div>
</template>

<script>
import TasksComponent from './components/Index.vue'

export default {
  name: 'TasksIndex',
  components: {
    TasksComponent,
  }
}
</script>
